// components/product-filter

import getParameter from "../../util/getParameter";
import mixitup from "mixitup";

function ProductFilter(productContainerClass) {

    this.productClass = '.product';
    this.productContainerClass = productContainerClass;
    this.containers = document.querySelectorAll(this.productContainerClass);
    this.filterPrefix = '.product_cat-';
    this.queryParam = 'filter';
    this.instances = [];

    var that = this,
        slugs,
        classes,
        mixer,
        config = {
        animation: {
            effects: 'fade'
        },
        controls: {
            toggleLogic: 'or'
        },
        selectors: {
            target: this.productClass
        },
        callbacks: {
            onMixStart: function(state, futureState) {
                console.log('onMixStart');
                that.handleEmptyMessage(futureState);
            },
            onMixEnd: function(state){
                console.log('onMixEnd');
                that.updateUrl(state);
                jQuery('html, body').animate({
                    scrollTop: jQuery('.product-filter__container').offset().top - 100
                }, 500);
            }
        }
    };

    slugs = getParameter(this.queryParam);
    if (slugs) {
        classes = this.getClasses(slugs);
        config.load = {
            filter: classes
        };
    }

    for (let i=0;i<this.containers.length;i++) {
        mixer = mixitup(this.containers[i], config);
        this.instances.push(mixer);
        this.handleEmptyMessage(mixer.getState());
    }

}

ProductFilter.prototype.updateUrl = function (state) {
    var slugs = this.getSlugs(state.activeFilter.selector);

    if (slugs != this.productClass) {
        window.history.pushState("object or string", document.title, location.pathname + "?" + this.queryParam + "=" + slugs);
    }
    else {
        window.history.pushState("object or string", document.title, location.pathname);
    }
}

ProductFilter.prototype.handleEmptyMessage = function (state) {
    var parentNode = state.container.parentNode;
    if (state.totalShow < 1) {
        // show empty message
        jQuery(parentNode.querySelector('.empty-message')).slideDown();
    }
    else {
        // hide empty message
        jQuery(parentNode.querySelector('.empty-message')).slideUp();
    }
}

ProductFilter.prototype.getSlugs = function (classString) {
    var slugs = classString.replaceAll(this.filterPrefix,"");
    slugs = slugs.split(", ");
    slugs.sort();
    slugs = slugs.join(",");
    return slugs;
}

ProductFilter.prototype.getClasses = function (slugs) {
    var classes = slugs.split(",");
    classes.sort();
    var classString = "";
    for (var i=0; i < classes.length; i++) {
        classString += this.filterPrefix + classes[i];
        if (i != (classes.length - 1)) {
            classString += ", ";
        }
    }
    return classString;
}

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

export default ProductFilter;



// WEBPACK FOOTER //
// ./js/components/product-filter/index.js